import React from "react";
import { components } from "react-select";
import Select from "react-select/async";

const InputSelectCustom = ({
  name,
  placeholder,
  optionsData,
  stateSelected,
  isClearable = false,
  isDisabled = false,
  isLoading = false,
  id,
  handleOnMenuScrollToBottom = () => {},
  handleOnChange = () => {},
  handleOnOpenMenu = () => {},
  loadOptions = () => {},
}) => {
  const DropdownIndicator = (props) => (
    <components.DropdownIndicator {...props}>
      <i className="fas fa-angle-down text-color-cinza4 font-size-18 icon-down-select" />
    </components.DropdownIndicator>
  );

  return (
    <Select
      value={stateSelected}
      // defaultValue={stateSelected}
      name={id || name}
      id={id || name}
      components={{ DropdownIndicator }}
      defaultOptions={optionsData}
      loadOptions={loadOptions}
      onChange={handleOnChange}
      isLoading={isLoading}
      // loadingMessage={"Carregando..."}
      isDisabled={isDisabled}
      onMenuOpen={handleOnOpenMenu}
      placeholder={placeholder}
      className="select-filter-custom"
      classNamePrefix="select-filter-custom"
      isClearable={isClearable}
      onMenuScrollToBottom={handleOnMenuScrollToBottom}
      theme={(theme) => ({
        ...theme,
        borderRadius: 4,
        colors: {
          ...theme.colors,
          primary25: "#0000001F",
          primary: "#0000001F",
        },
      })}
      styles={{
        indicatorSeparator: () => ({
          display: "none",
        }),

        option: (base, state) => ({
          ...base,
          alignItems: "center",
          fontWeight: 500,
          backgroundColor: state.isSelected
            ? "#263874"
            : state.isFocused
            ? "rgba(38, 56, 116, 0.1)"
            : "transparent",
          color: state.isSelected ? "#ffffff" : "#263874",
        }),

        singleValue: (base) => ({
          ...base,
          color: "#263874",
        }),
        control: (base, state) => ({
          ...base,
          minHeight: "40px",
          height: "40px",
          borderColor: state.isFocused ? "red" : "#0000001F",
          borderWidth: 1,
          paddingLeft: 5,
          paddingRight: 5,
        }),

        valueContainer: (base) => ({
          ...base,
          height: "40px",
          padding: "0 8px",
        }),
        input: (base) => ({
          ...base,
          margin: 0,
          padding: 0,
        }),
        indicatorsContainer: (base) => ({
          ...base,
          height: "40px",
        }),
      }}
    />
  );
};

export default InputSelectCustom;